import React, { useCallback, useEffect,useState } from "react";
import { useTranslation } from "react-i18next";

import DPCard from "../../../packages/DPCard";

import CIPEventDialog from "../../CIPEventDialog";
import CIPPaginatedTable from "../../CIPPaginatedTable";
import SkipDialog from "../SkipDialog";

import {
  CIP_SOURCE_OPTIONS,
  CustomModalButtons,
} from "../../../constants/global.constants";
import { CIP_CARD_IDS } from "../../../constants/global.constants";

import { CalendarGreenIcon } from "../../../assets/icons";

const RecurrentCIP = ({
  setCIPMode,
  CIPNeverShowAgain,
  setCIPNeverShowAgain,
  selectedTrain,
  selectedSheet,
  hasRecurrentCIPs,
  switchTo,
  setSwitchTo,
  disabled,
}) => {
  const { t } = useTranslation();

  const [showCIPEventDialog, setShowCIPEventDialog] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [showSkipDialog, setShowSkipDialog] = useState(false);
  const [isProceed, setIsProceed] = useState(false);

  const handleDialogClose = ({ target }) => {
    setShowSkipDialog(false);

    if (target.id === CustomModalButtons.CONFIRM) {
      setIsProceed(true);
    }
  };

  const handleInterruptLogic = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowSkipDialog(true);
  }, []);

  const showLoaderHandler = (shouldLoad) => {
    if (shouldLoad) {
      setCIPMode(CIP_SOURCE_OPTIONS.RECURRENT);
      setShowTable(true);
    } else {
      setCIPMode(null);
      setShowTable(false);
    }
  };

  const resetCIPMode = () => {
    setCIPMode(null);
    setShowTable(false);
  };

  useEffect(() => {
    if (isProceed) {
      setShowCIPEventDialog(true);
      setIsProceed(false);
    }
  }, [isProceed]);

  useEffect(() => {
    if (hasRecurrentCIPs) {
      setShowTable(true);
    } else {
      setShowTable(false);
    }
  }, [hasRecurrentCIPs, selectedTrain, selectedSheet]);

  // handle switch between modes
  useEffect(() => {
    if (switchTo === CIP_SOURCE_OPTIONS.RECURRENT) {
      const recurrentCard = document.getElementById(CIP_CARD_IDS.RECURRENT);
      recurrentCard.click();
      setSwitchTo(null);
    } else if (switchTo === CIP_SOURCE_OPTIONS.BULK) {
      setShowTable(false);
    }
  }, [switchTo]);

  return (
    <>
      {!showTable ? (
        <DPCard
          id={CIP_CARD_IDS.RECURRENT}
          hoverable
          disabled={disabled}
          onCardClick={(e) =>
            !CIPNeverShowAgain && !isProceed
              ? handleInterruptLogic?.(e)
              : setShowCIPEventDialog(true)
          }
        >
          <CalendarGreenIcon className="cip-section-icon" />
          <p className="description">
            {t("CIPSpecifications.addRecurrentCIP")}
          </p>
        </DPCard>
      ) : (
        <CIPPaginatedTable
          selectedTrain={selectedTrain}
          source={CIP_SOURCE_OPTIONS.RECURRENT}
          resetCIPMode={resetCIPMode}
          enableAdd
          enableActions
          exportFileName={t("excelSheetNames.cipsAndPlantShutdowns")}
        />
      )}
      {showCIPEventDialog && (
        <CIPEventDialog
          onModalClose={() => setShowCIPEventDialog(false)}
          showLoader={showLoaderHandler}
          source={CIP_SOURCE_OPTIONS.RECURRENT}
        />
      )}
      {showSkipDialog && (
        <SkipDialog
          onClose={handleDialogClose}
          CIPNeverShowAgain={CIPNeverShowAgain}
          setCIPNeverShowAgain={setCIPNeverShowAgain}
        />
      )}
    </>
  );
};

export default RecurrentCIP;
